// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Nachtrag, NachtragDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useCreateBaustelleNachtrag(): (
  baustellenId: string,
  requestBody: NachtragDaten
) => Promise<Nachtrag> {
  const getAPI = useGetApi();
  return useCallback(
    async (baustellenId, requestBody) =>
      (await getAPI()).baustellen.createBaustelleNachtrag({
        baustellenId,
        requestBody,
      }),
    [getAPI]
  );
}
